// extracted by mini-css-extract-plugin
module.exports = {"red":"Template_red__1gnC4","space":"Template_space__2h2Pz","backGround":"Template_backGround__bpEHj","backGroundGray":"Template_backGroundGray__YpN3e"};